import type { Options } from '@brighterly/lib-core-types/options/interfaces'

import { useCsRoutes } from '@shared/api'

import { useOptionsStore } from './store'

interface OptionsApiOptions {
  onError?: (err: any) => void
}
export const useOptionsApi = async (options?: OptionsApiOptions): Promise<Options | null> => {
  const { $axios } = useNuxtApp()
  const url = useCsRoutes('options')

  const optionsStore = useOptionsStore()

  try {
    const { data } = await $axios.get(url!)

    const options = data || null
    optionsStore.setOptions(options)

    return options
  } catch (err) {
    options?.onError?.(err)
    return null
  }
}
